
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club-unimarc",
      function () {
        return require("private-next-pages/club-unimarc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/club-unimarc"])
      });
    }
  